import { createStyles } from 'antd-style';
import type React from 'react';
import type { ReactNode } from 'react';

const useStyles = createStyles(({ token, css }) => ({
  muted: css`
    color: ${token.colorTextSecondary};
  `,
  tertiary: css`
    color: ${token.colorTextTertiary};
  `,
  danger: css`
    color: ${token.colorErrorText};
  `,
  success: css`
    color: ${token.colorSuccessText};
  `,
  warning: css`
    color: ${token.colorWarningText};
  `,
}));

export interface MutedTextProps {
  children: ReactNode;
  tone?: 'secondary' | 'tertiary' | 'danger' | 'success' | 'warning';
  className?: string;
}

export const MutedText: React.FC<MutedTextProps> = ({
  children,
  tone = 'secondary',
  className,
}) => {
  const { styles, cx } = useStyles();
  const cls =
    tone === 'tertiary'
      ? styles.tertiary
      : tone === 'danger'
        ? styles.danger
        : tone === 'success'
          ? styles.success
          : tone === 'warning'
            ? styles.warning
            : styles.muted;
  return <span className={cx(cls, className)}>{children}</span>;
};

export interface EmptyDashProps {
  className?: string;
}

export const EmptyDash: React.FC<EmptyDashProps> = ({ className }) => (
  <MutedText tone="tertiary" className={className}>
    -
  </MutedText>
);
